export default __webpack_public_path__ + "static/media/min- (2).8c30f442.png";